import React from 'react'
import { GregorianToJalali2 } from '../../utilities/convertTime'
import { UploadsUrl } from '../../services/url'

const Comment = (props) => {
  return (
    <div className='comment-box box-shadow'>
      <div className='top-section'>
        <div className='avatar'>
          <img
            className='box-shadow'
            src={`${UploadsUrl}/${props.avatar}`}
            alt='avatar'
          />
        </div>
        <div className='detatil'>
          <span className='name'>{props.name}</span>
          <span className='data'>
            <span>تاریخ</span>
            <span>{GregorianToJalali2(props.data)}</span>
          </span>
        </div>
      </div>
      <div className='comment'>{props.comment}</div>
    </div>
  )
}
export default Comment
